import request from '@/utils/request'

// 查询帖子
export function queryForumList(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/forum.listForumPcCmd',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
// 审核
export function judgeForum(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/forum.judgeForum',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
// 删除
export function deleteForum(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/forum.deleteForum',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
